import MicrositeCard from "./MicrositeCard"
import { styled } from "@mui/material/styles"
import PortableText from "Components/PortableText/PortableText"
import { IMicrositeCard } from "data/contentData/interfaces/mongodb/IMicrositeCard"

export default function MicrositeCardContainer({
  cards,
}: {
  cards: IMicrositeCard[]
}) {
  const headerCard = cards.filter((x) => !x.more?.href)[0]
  return (
    <>
      <StyledContentCardWrapper>
        <PortableText value={headerCard.blockContent} />
      </StyledContentCardWrapper>
      <StyledWrapper>
        {cards
          .filter((x) => x.more?.href)
          .map((card, index) => (
            <MicrositeCard
              card={card}
              key={card.contentGuid}
              index={index}
              numberOfArticles={cards.length}
            />
          ))}
      </StyledWrapper>
    </>
  )
}

const StyledContentCardWrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
}))

const StyledWrapper = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  gridAutoRows: "min-content",
  gap: theme.spacing(2),
  width: "100%",
}))
